import { Type } from 'class-transformer';
import { IsInt, Max, Min } from 'class-validator';

/**
 * Limiti delle soglie di `/admin/insights`, SSOT condivisa da backend
 * (`UpdateInsightsThresholdsDto`) e dal form del frontend. Non sono
 * decorativi: una soglia di silenzio a 3650 giorni spegnerebbe la sezione
 * "clienti fermi" senza che nessuno se ne accorga.
 */
export const INSIGHTS_STALL_DAYS_MIN = 1;
export const INSIGHTS_STALL_DAYS_MAX = 90;
export const INSIGHTS_ONBOARDING_GRACE_DAYS_MIN = 0;
export const INSIGHTS_ONBOARDING_GRACE_DAYS_MAX = 180;
export const INSIGHTS_REPEATED_NC_THRESHOLD_MIN = 1;
export const INSIGHTS_REPEATED_NC_THRESHOLD_MAX = 50;

/**
 * Form delle tre soglie: tutti i campi sono presenti perché il form li mostra
 * sempre tutti e tre, mentre il PATCH invia solo quelli davvero cambiati
 * (`toUpdateInsightsThresholdsPayload`) — così salvare una soglia non
 * sovrascrive le altre con i valori letti all'apertura della modale.
 */
export class UpdateInsightsThresholdsFormDto {
  @Type(() => Number)
  @IsInt()
  @Min(INSIGHTS_STALL_DAYS_MIN)
  @Max(INSIGHTS_STALL_DAYS_MAX)
  stallDays!: number;

  @Type(() => Number)
  @IsInt()
  @Min(INSIGHTS_ONBOARDING_GRACE_DAYS_MIN)
  @Max(INSIGHTS_ONBOARDING_GRACE_DAYS_MAX)
  onboardingGraceDays!: number;

  @Type(() => Number)
  @IsInt()
  @Min(INSIGHTS_REPEATED_NC_THRESHOLD_MIN)
  @Max(INSIGHTS_REPEATED_NC_THRESHOLD_MAX)
  repeatedNcThreshold!: number;
}
